export default __webpack_public_path__ + "static/quotes-img-212bd04846f4f3427506c64860d1a9b4.jpg";